export default "__VITE_ASSET__Md4x7Wdu__"